<template>
  <div class="layout-sidebar flex flex-column" style="background-color: #1B2842" :style="{width: currentSidebarWidth + 'px'}">
    <div class="overflow-y-auto">
      <ul class="list-none p-2 m-0" v-for="(item,i) of itemMenu" :key="item.label || i">
        <li v-if="!item.roles || item.roles.includes(me.role)">
          <div v-if="item.children">
            <div v-ripple class="p-3 flex align-items-center text-indigo-300 cursor-pointer p-ripple"
                 v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'slidedown', leaveToClass: 'hidden', leaveActiveClass: 'slideup' }">
              <i v-if="item.icon" :class="item.icon" class="mr-2 text-xl"></i>
              <span class="font-medium text-lg">{{ item.label }}</span>
              <i class="pi pi-chevron-down ml-auto"></i>
            </div>
            <ul class="list-none p-0 m-0 overflow-hidden" :class="{'hidden': item.hidden && !menuInManagement}">
              <li v-for="(child, j) of item.children" :key="child.label || j">
                <router-link
                  v-ripple
                  :class="matchedMenus.find(m => m.name === child.name) ? 'active-route' : ''"
                  @click="selectMenu(child)"
                  :to="child.to?? ''"
                  class="flex align-items-center cursor-pointer p-3 text-indigo-100 hover:text-indigo-50 hover:bg-indigo-600 border-round transition-colors transition-duration-150 p-ripple">
                  <i v-if="child.icon" :class="child.icon" class="mr-2 text-xl"></i>
                  <span class="font-medium text-lg">{{ child.label }}</span>
                </router-link>
              </li>
            </ul>
          </div>
          <router-link v-else
            :class="matchedMenus.find(m => m.name === item.name) ? 'active-route' : ''"
            class="flex align-items-center cursor-pointer p-3 text-indigo-100 hover:text-indigo-50 hover:bg-indigo-600 border-round transition-colors transition-duration-150 p-ripple"
            v-ripple
            @click="selectMenu(item)" :to="item.to?? ''"
           >
            <i v-if="item.icon" :class="item.icon" class="mr-2 text-xl"></i>
            <span class="font-medium text-lg">{{ item.label }}</span>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="mt-auto">
      <hr class="mb-3 mx-3 border-top-1 border-none border-bluegray-600" />
      <ul class="list-none p-2 m-0 hidden origin-bottom animation-duration-150 overflow-hidden animation-ease-in-out">
        <li>
          <a @click="logout()" v-ripple class="flex align-items-center cursor-pointer p-3 text-indigo-100 hover:text-indigo-50 hover:bg-indigo-600 border-round
                                    transition-duration-150 transition-colors p-ripple">
            <i class="pi pi-sign-out mr-2"></i>
            <span class="font-medium text-lg">Déconnexion</span>
          </a>
        </li>
      </ul>
      <a v-ripple class="m-3 px-3 py-2 flex align-items-center border-round cursor-pointer text-indigo-100 hover:text-indigo-50 hover:bg-indigo-600
                                transition-duration-150 transition-colors p-ripple"
         v-styleclass="{ selector: '@prev', enterClass: 'hidden', enterActiveClass: 'slidedown', leaveToClass: 'hidden', leaveActiveClass: 'slideup'}">
        <span class="font-medium text-lg">{{ me?.firstname + ' ' + me?.lastname }}</span>
        <i class="pi pi-chevron-up ml-auto"></i>
      </a>
    </div>
  </div>
  <Dialog v-model:visible="loading" :show-header="false" modal class="loading-dialog">
    <ProgressSpinner />
  </Dialog>
</template>

<script>
import NavigationItems from '@/config/navigation-items'
import {mapState} from 'vuex'

export default {
  props: ['currentSidebarWidth'],
  computed: {
    ...mapState({
      menuSelected: state => state.sidebar.selected,
      me: state => state.auth.me,
    }),
    itemMenu () {
      const items = NavigationItems
      return items
    },
  },
  data () {
    return {
      loading: false,
      currentMenu: null,
      hover: false,
      localMenuSelected: '',
      matchedMenus: [],
      flatMenuManagement: null,
      menuInManagement: false,
      initRoute: false
    }
  },
  watch: {
    '$route.name' (val) {
      document.title = this.$route.meta.title
      this.matchedMenus = this.$route.matched
      if (!this.initRoute) {
        this.flatMenuManagement = this.flattenJSON(this.itemMenu[1])
        this.menuInManagement = Object.values(this.flatMenuManagement).includes(val)
        this.initRoute = true
      }
    },
  },
  methods: {
    flattenJSON (obj = {}, res = {}, extraKey = '') {
      for(const key in obj){
        if(typeof obj[key] !== 'object'){
          res[extraKey + key] = obj[key]
        }else{
          this.flattenJSON(obj[key], res, `${extraKey}${key}.`)
        }
      }
      return res
    },
    async logout () {
      this.loading = true
      await new Promise(resolve => setTimeout(resolve, 500))
      await this.$store.dispatch('auth/logout')
      this.loading = false
      this.$router.push({ name: 'Login'})
    },
    selectMenu (item) {
      if (!item.name) {
        return
      }
      if (item.to) {
        this.$store.dispatch('sidebar/changeMenu', item.name)
        if (item.params) {
          this.$router.push({ name: item.to, params: item.params })
        } else {
          this.$router.push({ name: item.to })
        }
      }
    }
  },
}
</script>

<style scoped>
.svg-inline--fa {
  font-size: 1.6em !important;
 }
.triangle-ripple {
  clip-path: circle(40%);
}
</style>
